"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateUrlWithLang = void 0;
var next_intl_1 = require("next-intl");
var useGenerateUrlWithLang = function () {
    var lang = (0, next_intl_1.useLocale)();
    return function (originUrl) {
        if (originUrl.toLowerCase().startsWith('mailto')) {
            return originUrl;
        }
        if (!originUrl.startsWith('/')) {
            originUrl = '/' + originUrl;
        }
        return '/' + lang + originUrl;
    };
};
exports.useGenerateUrlWithLang = useGenerateUrlWithLang;
